import Form from 'src/utils/Form.js'

class Rate extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  static dailyRates(parameters, then) {
      return new Form().get(`/rates/daily?${parameters}`).then(then);
  }
}

export default Rate
